import React from 'react';
import PropTypes from 'prop-types';

const Chip = ({  color, borderColor , label , onDelete , borderStyle , borderWidth , closeBtnClassName, closeBtnColor , labelColor }) => {
    return <div style={{
        backgroundColor: color,
        borderColor: borderColor,
        borderStyle: borderStyle,
        borderWidth: borderWidth,
        borderRadius: 4,
        display:"inline-block",
        paddingLeft: 12,
        paddingRight: 12,
        paddingTop: 4,
        paddingBottom: 4,
        whiteSpace: "nowrap",
        marginBottom: 4
    }}><span style={{ cursor: "default" , color : labelColor }}>{label}</span> <span title="Click to remove" style={{ marginLeft: 4 , cursor: "pointer" , color: closeBtnColor  }} className={closeBtnClassName} onClick={onDelete}><i className="fa fa-close"/></span>
    </div>
};

Chip.propTypes = {
    color: PropTypes.string,
    borderColor: PropTypes.string,
    label: PropTypes.any,
    closeBtnClassName: PropTypes.string,
    borderWidth: PropTypes.number,
    borderStyle: PropTypes.string,
    onDelete: PropTypes.func,
    closeBtnColor: PropTypes.string,
    labelColor: PropTypes.string,
};

Chip.defaultProps = {
    color: "#eeeeee",
    borderColor: "#cbcbcb",
    label: "",
    borderStyle: "solid",
    borderWidth: 0,
    closeBtnClassName: "",
};

export default Chip;


// WEBPACK FOOTER //
// ./src/components/Chip/Chip.js